import { useRef } from "react";
import { motion, useInView } from "framer-motion";
import { Phone } from "lucide-react";
import { COMPANY } from "../data";

const PERSONS = [
  { name: "ANDREAS MÜLLER", role: "Geschäftsführer", mobile: COMPANY.mobileAndreas, link: COMPANY.mobileAndreasLink },
  { name: "RICHARD MÜLLER", role: "Geschäftsführer", mobile: COMPANY.mobileRichard, link: COMPANY.mobileRichardLink },
];

export const About = () => {
  const imgRef = useRef(null);
  const imgInView = useInView(imgRef, { once: true, margin: "-100px" });

  return (
    <section id="ueber-uns" className="bg-white py-24 sm:py-32" data-testid="about-section">
      <div className="max-w-7xl mx-auto px-5 sm:px-8">
        <motion.h2
          className="font-heading text-3xl sm:text-4xl lg:text-5xl font-bold text-[#1A3C1A]"
          initial={{ opacity: 0, y: 30 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }} transition={{ duration: 0.7 }}
          data-testid="about-headline"
        >
          Handwerk mit Herz. Familie Müller.
        </motion.h2>

        <div className="mt-14 grid lg:grid-cols-2 gap-12 lg:gap-16 items-start">
          <motion.div
            ref={imgRef}
            className="rounded-lg border-2 border-[#2A5C2A]/40 p-2"
            initial={{ opacity: 0, y: 30 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }} transition={{ duration: 0.7 }}
          >
            {/* Foto Andreas & Richard Müller — Team-Foto
                aus: zimmerei-mueller-zeitlofs.de/wp-content/uploads/2025/03/zimmerei-mueller-zeitlofs-team-1024x768.jpg */}
            <img
              src="https://images.unsplash.com/photo-1601058268499-e52658b8bb88?q=80&w=1000&auto=format&fit=crop"
              alt="Team Zimmerei Müller — Andreas & Richard Müller"
              className={`team-photo w-full aspect-[4/3] object-cover rounded ${imgInView ? "in-view" : ""}`}
              data-testid="about-team-photo"
            />
          </motion.div>

          <motion.div
            initial={{ opacity: 0, y: 30 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }} transition={{ duration: 0.7, delay: 0.15 }}
          >
            <p className="text-[#2A2A2A] text-base md:text-lg leading-relaxed">
              Zimmerei Müller steht für präzises Handwerk, persönliche Betreuung und Qualität,
              die hält. Andreas und Richard Müller führen den Betrieb gemeinsam — von der ersten
              Beratung bis zur letzten Schraube sind wir dabei.
            </p>
            <p className="mt-5 text-[#2A2A2A] text-base md:text-lg leading-relaxed">
              Unser Zuhause ist der Spessart. Unsere Kunden kennen wir beim Namen. Unsere Arbeit
              sehen Sie auf jedem Dach, das wir gebaut haben.
            </p>

            <div className="mt-10 grid sm:grid-cols-2 gap-5">
              {PERSONS.map((p, i) => (
                <motion.div
                  key={p.name}
                  className="rounded-lg bg-[#F8F7F4] border border-[#ECEAE4] p-6"
                  initial={{ opacity: 0, y: 20 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }}
                  transition={{ duration: 0.5, delay: 0.2 + i * 0.12 }}
                  data-testid={`person-card-${i === 0 ? "andreas" : "richard"}`}
                >
                  <div className="font-heading font-bold text-lg text-[#1A3C1A]">{p.name}</div>
                  <div className="font-condensed tracking-[0.15em] uppercase text-sm text-[#7A5C38] mt-1">{p.role}</div>
                  <a href={`tel:${p.link}`} className="mt-3 inline-flex items-center gap-2 text-[#2A5C2A] font-semibold text-sm hover:text-[#1A3C1A] transition-colors">
                    <Phone size={14} /> {p.mobile}
                  </a>
                </motion.div>
              ))}
            </div>
          </motion.div>
        </div>
      </div>
    </section>
  );
};
